import React from "react";
import { useTranslation } from "react-i18next";
import { Form, Dropdown, Segment, Loader } from "semantic-ui-react";
import GruppoSelezione from "../common/GruppoSelezione"; // Assuming this is a custom component for selection groups
import { lang } from "moment";

const PreferenzeLezioneForm = ({
  datiScuola,
  selectedSpecialita,
  selectedLivello,
  selectedArea,
  setSelectedSpecialita,
  setSelectedLivello,
  setSelectedArea,
  onNext,
  isLoading,
  numPupils,
  setNumPupils,
  selectedLang,
  setSelectedLang,
}) => {
  const { t } = useTranslation();

  // Prepare dropdown options
  const specialitaOptions = datiScuola?.specialità
    ? Object.entries(datiScuola.specialità)
        .filter(([k, v]) => v)
        .map(([key, value]) => ({
          key,
          img: require(`../../assets/images/specialita/${
            value?.simbolo === null ? "0" : value?.simbolo
          }b.jpg`),
          text: value.text,
        }))
    : [];

  const livelloOptions = datiScuola?.livelli
    ? Object.entries(datiScuola.livelli)
        .filter(([k, v]) => v)
        .map(([key, value]) => ({
          key,
          img: require(`../../assets/images/livelli/${
            value?.simbolo === null ? "0" : value?.simbolo
          }.jpg`),
          text: value.text,
        }))
    : [];

  const langOptions = [
    {
      text: "NO PREF",
      img: require(`../../assets/images/defaults/free.jpg`),
      key: "",
    },
  ];

  for (let key in datiScuola.linguePrivate) {
    console.log("Lingua:", key, "Codice:", datiScuola.linguePrivate[key]);
    langOptions.push({
      text: datiScuola.linguePrivate[key].isoCode.toUpperCase(),
      img: require(`../../assets/images/flags/${datiScuola.linguePrivate[key].id}.jpg`),
      key: key,
    });
  }

  const numAllieviOptions = Array.from({ length: 5 }, (_, i) => {
    return {
      key: (i + 1).toString(),
      text: (i + 1).toString(),
      img: require(`../../assets/images/people/${i + 1}.jpg`),
    };
  });

  const areaOptions = datiScuola?.areeOperative
    ? Object.entries(datiScuola.areeOperative)
        .filter(([k, v]) => v)
        .map(([key, value]) => ({
          key,
          value: key,
          text: value,
        }))
    : [];

  if (isLoading) {
    return (
      <Segment>
        <Loader active inline="centered" />
      </Segment>
    );
  }

  return (
    <Segment>
      <Form>
        <Form.Field>
          <GruppoSelezione
            width={97}
            elementi={specialitaOptions}
            onChange={(key) => setSelectedSpecialita(key)}
            selezione={selectedSpecialita}
            titolo={t("scegli_specialita")}
          ></GruppoSelezione>
        </Form.Field>
        <Form.Field>
          <GruppoSelezione
            width={97}
            elementi={livelloOptions}
            onChange={(key) => setSelectedLivello(key)}
            selezione={selectedLivello}
            titolo={t("scegli_livello")}
          ></GruppoSelezione>
        </Form.Field>
        <Form.Field>
          <GruppoSelezione
            width={130}
            elementi={areaOptions}
            onChange={(key) => setSelectedArea(key)}
            selezione={selectedArea}
            titolo={t("scegli_area")}
          ></GruppoSelezione>
        </Form.Field>
        <Form.Field>
          <GruppoSelezione
            width={97}
            elementi={numAllieviOptions}
            onChange={(key) => setNumPupils(key)}
            selezione={numPupils}
            titolo={t("scegli_numero_allievi")}
          ></GruppoSelezione>
        </Form.Field>
        <Form.Field>
          <GruppoSelezione
            width={97}
            elementi={langOptions}
            onChange={(key) => setSelectedLang(key)}
            selezione={selectedLang}
            titolo={t("scegli_lingua")}
          ></GruppoSelezione>
        </Form.Field>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Form.Button
            primary
            onClick={onNext}
            disabled={
              !selectedSpecialita ||
              !selectedLivello ||
              !selectedArea ||
              !numPupils ||
              !selectedLang
            }
          >
            {t("prosegui")}
          </Form.Button>
        </div>
      </Form>
    </Segment>
  );
};

export default PreferenzeLezioneForm;
